var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "main-nav-container",
      attrs: { id: "page-header", role: "banner" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "content-container", attrs: { id: "headercontent" } },
          [
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-light navbar-expand-lg d-block login-page"
              },
              [
                _vm.isInPrintMode
                  ? _c(
                      "div",
                      { staticClass: "logocontainer" },
                      [_c("stea-logo")],
                      1
                    )
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "row justify-content-between" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("stea-logo-link", {
                                staticClass: "d-inline small"
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-2" },
                            [_c("language-selection")],
                            1
                          )
                        ]
                      )
                    ])
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }